import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import Accordion from '../Accordion/index.jsx';
import CMSContent from '../CMSContent/index.jsx';
import LoadingOverlay from '../LoadingOverlay/index.jsx';
import Spinner from '../Spinner/index.jsx';

import AjaxService from '../../Services/Ajax/index.jsx';


var id = 1;


/**
 * A helper component for rendering a group of related checkboxes, used in
 * filtering feed data.
 *
 * This component initialises with all options (`this.props.options`) selected,
 * and will fire the `onChange` prop callback whenever a checkbox changes. This
 * callback will be given `null` when all options are selected, or an array of
 * the ids of the selected options.
 */
class CheckboxGroupFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: null,
      idPrefix: String(id++)
    };

    this.onChange = this.onChange.bind(this);
    this.changed = this.changed.bind(this);
  }

  onChange(event) {
    var name = event.target.value;
    var checked = event.target.checked;

    var options = this.props.options;

    this.setState(function(oldState) {
      var newState = {};
      var selected = oldState.selected;
      if (! checked) {
        // deselecting an option
        if (selected) {
          // remove the option from the array
          var index = selected.indexOf(name);
          if (index > -1) {
            var tmp = selected.slice(0, index).concat(selected.slice((index + 1)));
            newState.selected = tmp;
          }
        } else {
          // create an array with all options except the one de-selected.
          var tmp = [];
          for (var i = 0; i < options.length; i++) {
            if (options[i].id == name) {
              continue;
            }
            tmp.push(options[i].id);
          }

          newState.selected = tmp;
        }
      } else {
        // selecting an option
        if (selected) {
          var tmp = Array.from(selected);
          if (selected.indexOf(name) == -1) {
            tmp.push(name);
          }

          // check if all are selected now
          var allSelected = true;
          for (var i = 0; i < options.length; i++) {
            if (tmp.indexOf(options[i].id) == -1) {
              allSelected = false;
              break;
            }
          }

          if (allSelected) {
            tmp = null;
          }
          newState.selected = tmp;
        }
      }

      return newState;
    }, this.changed);
  }

  changed() {
    if (this.props.onChange) {
      this.props.onChange(this.state.selected);
    }
  }

  render() {
    var result;

    if (this.props.options) {
      result = [];

      for (var i = 0; i < this.props.options.length; i++) {
        var option = this.props.options[i];

        var checked = true;
        if (this.state.selected) {
          if (this.state.selected.indexOf(option.id) == -1) {
            checked = false;
          }
        }

        result.push(
          <Form.Check
            key={this.state.idPrefix + '-' + option.id}
            type="switch"
            custom
            id={this.state.idPrefix + '-' + option.id}
            className="custom-switch--reverse custom-switch--aligned my-1"
            value={option.id}
            label={option.label}
            checked={checked}
            onChange={this.onChange}
          />
        );
      }
    }


    if (result) {
      return result;
    } else {
      return <React.Fragment />;
    }
  }
}


class ContentFeedFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      types: null,
      typesSelected: null,
      authors: null,
      order: null,
      orderSelected: null,
      orderBy: null,
      orderBySelected: null
    };

    this.handleResponse = this.handleResponse.bind(this);
    this.authorsChanged = this.authorsChanged.bind(this);
    this.onOrderByChanged = this.onOrderByChanged.bind(this);
    this.onOrderChanged = this.onOrderChanged.bind(this);
    this.typesChanged = this.typesChanged.bind(this);
    this.onFetchChange = this.onFetchChange.bind(this);
  }

  fetchFilters() {
    AjaxService.fetch('cs:content-feed-filters')
      .then(this.handleResponse);
  }

  handleResponse(response) {
    var newState = {};
    if (response.types) {
      newState.types = response.types;
    }
    if (response.authors) {
      newState.authors = response.authors;
    }
    if (response.order) {
      newState.order = response.order;
      newState.orderSelected = response.order[0].id;
    }
    if (response.orderBy) {
      newState.orderBy = response.orderBy;
      newState.orderBySelected = response.orderBy[0].id;
    }

    this.setState(newState);
  }

  onFetchChange(isFetching) {
    this.setState({ fetching: isFetching });
  }

  componentDidMount() {
    this.fetchFilters();

    if (this.props.api.addFetchListener) {
      this.props.api.addFetchListener(this.onFetchChange);
    }
  }

  componentWillUnmount() {
    if (this.props.api.removeFetchListener) {
      this.props.api.removeFetchListener(this.onFetchChange);
    }
  }

  authorsChanged(authors) {
    if (this.props.api && this.props.api.setAuthors) {
      this.props.api.setAuthors(authors);
    }
  }

  onOrderByChanged(event) {
    this.setState({ orderBySelected: event.target.value }, this.orderByChanged);
  }

  orderByChanged() {
    if (this.props.api && this.props.api.setOrderBy) {
      this.props.api.setOrderBy(this.state.orderBySelected);
    }
  }

  onOrderChanged(event) {
    this.setState({ orderSelected: event.target.value }, this.orderChanged);
  }

  orderChanged() {
    if (this.props.api && this.props.api.setOrder) {
      this.props.api.setOrder(this.state.orderSelected);
    }
  }

  typesChanged(types) {
    if (this.props.api && this.props.api.setArticleTypes) {
      this.props.api.setArticleTypes(types);
    }
  }

  authorsContent() {
    if (this.state.authors) {
      return (
        <CheckboxGroupFilter
          options={this.state.authors}
          onChange={this.authorsChanged}
        />
      );
    } else {
      return null;
    }
  }

  orderByContent() {
    var result;

    if (this.state.orderBy) {
      var tmp = [];
      for (var i = 0; i < this.state.orderBy.length; i++) {
        var orderBy = this.state.orderBy[i];
        tmp.push(
          <option key={i} value={orderBy.id}>{orderBy.label}</option>
        );
      }
      result = (
        <Col key="order-by" md={6}>
          <Form.Control
            as="select"
            custom
            className="mb-3 mb-md-0"
            value={this.state.orderBySelected}
            onChange={this.onOrderByChanged}
          >
            {tmp}
          </Form.Control>
        </Col>
      );
    }

    return result;
  }

  orderContent() {
    var result;

    if (this.state.order) {
      var tmp = [];
      for (var i = 0; i < this.state.order.length; i++) {
        var order = this.state.order[i];
        tmp.push(
          <option key={i} value={order.id}>{order.label}</option>
        );
      }
      result = (
        <Col key="order" md={6}>
          <Form.Control
            as="select"
            custom
            value={this.state.orderSelected}
            onChange={this.onOrderChanged}
          >
            {tmp}
          </Form.Control>
        </Col>
      );
    }

    return result;
  }

  typesContent() {
    if (this.state.types) {
      return (
        <CheckboxGroupFilter
          options={this.state.types}
          onChange={this.typesChanged}
        />
      );
    } else {
      return null;
    }
  }

  render() {
    var content = [];

    var types = this.typesContent();
    var authors = this.authorsContent();
    if (types || authors) {
      var inner = [];

      if (types) {
        inner.push(
          <p key="content-title" className="mb-2"><strong>Article Types:</strong></p>
        );
        inner = inner.concat(types);
      }
      if (authors) {
        inner.push(
          <p key="authors-title" className="mt-3 mb-2"><strong>Authors:</strong></p>
        );
        inner = inner.concat(authors);
      }
      content.push(
        <Row key="types">
          <Col xs="auto">
            {inner}
          </Col>
        </Row>
      );
    }

    var orderBy = this.orderByContent();
    var order = this.orderContent();
    if (order || orderBy) {
      var inner = [];

      if (orderBy) {
        inner.push(orderBy);
      }
      if (order) {
        inner.push(order);
      }

      content.push(
        <p key="order-title" className="mt-3 mb-2"><strong>Sort by:</strong></p>
      );
      content.push(
        <Row key="order">
          {inner}
        </Row>
      );
    }

    if (! content.length) {
      content.push(
        <Spinner key="spinner" />
      );
    }

    return (
      <Accordion title="Filters">
        <LoadingOverlay disabled={! this.state.fetching}>
          {content}
        </LoadingOverlay>
      </Accordion>
    );
  }
}


export default ContentFeedFilters;

